import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .detected-link,.monaco-editor .detected-link-active{text-decoration:underline;text-underline-position:under}.monaco-editor .detected-link-active{color:var(--vscode-editorLink-activeForeground)!important;cursor:pointer}";
n(css,{});
export { css, css as default };
